import { ROLES, ORGANIZATION_HIERARCHY, LEADERS_BULK, CONFIGURATION_KEYS } from 'constants/enums'
import { get } from 'lodash'

export const tabs = [
  {
    id: 1,
    label: 'Detail',
    intlKey: 'tabs.detail',
    path: '/detail'
  },
  {
    id: 2,
    label: 'Participants',
    intlKey: 'tabs.participants',
    path: '/participants'
  },
  {
    id: 3,
    label: 'History Log',
    intlKey: 'tabs.history_log',
    path: '/history'
  }
]

export const tableHeaders = ({ organizationHierarchyId, activeRole, isContactLabelsEnabled }) => [
  {
    id: 0,
    label: '',
    intlKey: '',
    sortableId: '',
    selector: true
  },
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name',
    sortableId: 'person.firstName'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name',
    sortableId: 'person.lastName'
  },
  {
    id: 4,
    label: 'Email',
    intlKey: 'table.email',
    sortableId: 'person.email'
  },
  {
    id: 5,
    label: 'Award Unit',
    intlKey:
      activeRole === ROLES.GBT.u
        ? 'table.independent_award_centre'
        : 'table.award_unit',
    sortableId: 'organization.name'
  },
  // {
  //   id: 6,
  //   label: 'Participants',
  //   intlKey: 'table.participants',
  //   sortableId: 'organization.name'
  // },
  {
    id: 7,
    label: 'NAO',
    intlKey:
      organizationHierarchyId === ORGANIZATION_HIERARCHY.IC.id
        ? 'table.ic'
        : 'table.nao',
    sortableId: 'organization.parent.name',
    displayForRoles: [
      ROLES.IF_STAFF_SUPER.u,
      ROLES.IF_REGION.u,
      ROLES.IF_STAFF_USER.u,
      ROLES.IF_STAFF_VIEWER.u
    ]
  },
  {
    id: 8,
    label: 'Award Leader Labels',
    intlKey: 'table.contact_labels',
    sortableId: 'labels.label.name',
    hide: !isContactLabelsEnabled || activeRole === ROLES.LEADER.u
  },
  {
    id: 9,
    label: 'Status',
    intlKey: 'table.status',
    sortableId: 'person.personState.value'
  }

]

export const bulkAwardLeaderStateOptions = (configuration, intl) => {
  const options = []

  if (get(configuration, `values[${CONFIGURATION_KEYS.enableContactLabels.id}].booleanValue`)) {
    options.push({
      value: LEADERS_BULK.assignLabels.id,
      label: intl.formatMessage({ id: 'label.assign_labels', defaultMessage: 'Assign Labels' })
    })
  }

  if (get(configuration, `values[${CONFIGURATION_KEYS.enableContactLabels.id}].booleanValue`)) {
    options.push({
      value: LEADERS_BULK.unassignLabels.id,
      label: intl.formatMessage({ id: 'label.unassign_labels', defaultMessage: 'Unassign Labels' })
    })
  }

  return options
}

export const bulkForm = 'awardLeaders-bulkChange'
